import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  message :any;
  cancelButtonText = "Cancel"
  inited: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly dialogRef: MatDialogRef<ModalComponent>) {
      this.message = {
        data:{},
        buttons: [],
        template: undefined,
        style: {}
      }
    if(data?.message?.template){
        this.message.template = data.message.template;;
    }
    if(data?.message?.style){
      this.message.style = data.message.style;
    }
    this.dialogRef.updateSize('300vw','300vw')
  }
  ngOnInit(): void {
    this.dialogRef.afterOpened().subscribe(() => {
      this.inited = true;
    })
    
    let table: any;
    const cdkOverlay = document.getElementsByClassName('cdk-overlay-pane');
    const matContainer = document.getElementsByClassName('mat-dialog-container');
    if(cdkOverlay?.length > 0) {
      table = cdkOverlay[0];
      //table.setAttribute('style', 'border: solid 2px red; border-radius: 1px; -o-box-shadow: 0px -1px 8px #ACD2F8; -webkit-box-shadow: 0 0 3px 0 #007AEC, 0 1px 6px 0 rgba(0,122,236,0.4); 	box-shadow: 0 0 3px 0 #007AEC, 0 1px 6px 0 rgba(0,122,236,0.4); -moz-box-shadow: 0px -1px 8px #ACD2F8;');
    }
    if(this.message?.style && Object.keys(this.message.style).length > 0){
      for (const i in this.message.style){
        if(table){
          table.setAttribute('style',`${i}:${this.message.style[i]}`);
        }
      }
    }
    
    if(matContainer?.length > 0) {
      document.getElementsByClassName('mat-dialog-container')[0].setAttribute('style', 'padding:0px');
     }
  }

  
  closeModal(): void {
    this.dialogRef.close(true);
  }
}
